export function ChatBubble (props: {text: string}) {
    return <div className='border-black border-radius-4 padding-8 bg-white-off'>
        <h3>{props.text}</h3>
    </div>
}